module.exports = __webpack_public_path__ + "7daea9709eb5263a46d21b5c0527dfa3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/traumweltstadt.jpg
// module id = 500
// module chunks = 0